import { IAuthManager } from "../../../../OW.Remoting/Remoting/Auth/IAuthManager";
import { FormBase } from "./FormBase";
import { ILoginCredentialsProvider } from "./ILoginCredentialsProvider";
import { LoginForm } from "./LoginForm";
import { NavigationService } from "./NavigationService";

/**
 * VerificationForm class contains common logic for 2FA forms such
 * as SMSForm, EmailForm and TotpForm.
 */
export abstract class VerificationForm extends FormBase {
    //#region Fields
    protected _credentialsProvider: ILoginCredentialsProvider;
    protected _navigator: NavigationService;
    protected _keyId: string;
    //#endregion Fields

    constructor(
        credentialsProvider: ILoginCredentialsProvider,
        _authManager: IAuthManager,
        navigator: NavigationService,
        _onSuccessfulLogin: () => any) {
        super();

        this._credentialsProvider = credentialsProvider;
        this._navigator = navigator;
    }

    //#region Methods
    public initialize(): void {
        this.clearForm();
    }

    public clearForm(): void {
        this._keyId = "-1";
        this._clearVerificationCodeInput();
        this._clearError();
    }

    protected abstract _getVerificationCode(): string;
    protected abstract _getChooseAnotherOptionLink(): HTMLElement;
    protected abstract _clearVerificationCodeInput(): void;
    protected abstract _focusVerificationCodeInput(): void;

    /**
     * Registers an event listener that listens to a press of an enter key
     * and clicks the given toSubmitElement input.
     */
    protected _registerElementToSubmitByEnter(inputToListenToElement: HTMLElement, toSubmitElement: HTMLElement): void {
        const enterKeyCode = 13;

        inputToListenToElement.addEventListener("keypress", (event: KeyboardEvent) => {
            if (event.keyCode == enterKeyCode) {
                event.preventDefault();
                toSubmitElement.click();
            }
        });
    }

    protected _backToLoginForm(): void {
        this._navigator.navigate(this.constructor.name, LoginForm.name);
    }

    protected _fadeInFadeOutNewCodeHasBeenSentMessage(fadeInElement: HTMLElement, fadeOutElement: HTMLElement): void {
        const fadeInElementClass = "fade-in";
        const fadeOutElementClass = "fade-out";

        this._clearFadeAnimationFromElement(fadeInElement);
        this._clearFadeAnimationFromElement(fadeOutElement);

        // A goddamn hack to make it reanimate.
        // The animation wouldn't start if css class was simply removed
        // from the element and immediately added back. In that case the DOM wouldn't update.
        setTimeout(function() {
            fadeOutElement.classList.add(fadeOutElementClass);
            fadeInElement.classList.add(fadeInElementClass);
        }, 10);
    }

    private _clearFadeAnimationFromElement(element: HTMLElement): void {
        element.classList.remove("fade-out");
        element.classList.remove("fade-in");
    }
    //#endregion Methods
}
